export const Divider = () => {
  return (
    <div className="mb-l py-r">
      <div className="h-[1px] bg-structure-80" />
    </div>
  );
};
